export default __webpack_public_path__ + "static/media/Versions - vs Official vs Films_07.bc4a68f4.jpg";